import React from 'react';
import FieldMappingTab from '../../components/admin/FieldMappingTab';

const FeldmappingPage = () => {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Feldmapping</h1>
        <p className="text-sm text-gray-600">CSV-Felder zu Systemfeldern zuordnen</p>
      </div>
      <FieldMappingTab />
    </div>
  );
};

export default FeldmappingPage;
